import type { VariantProps } from 'class-variance-authority';
import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { cn } from '@/lib/cn';
import Icon from '../Icon/Icon';
import type { IconName } from '../Icon/iconMap';
import { buttonVariants } from '../ui/button';
export default forwardRef<HTMLButtonElement, ComponentPropsWithoutRef<'button'> & {
  iconName?: IconName;
  showChevron?: boolean;
  buttonVariant?: VariantProps<typeof buttonVariants>['variant'];
}>(function AvailableFilterChip(props, ref) {
  const {
    children,
    className,
    iconName,
    showChevron = false,
    buttonVariant = 'outline',
    ...rest
  } = props;
  return <button ref={ref} className={cn(buttonVariants({
    variant: buttonVariant,
    size: 'sm'
  }), 'gap-2', className)} {...rest}>
      {iconName && <Icon iconName={iconName} />}
      {children}
      {showChevron && <Icon iconName="ChevronDownIcon" />}
    </button>;
});